
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npEmailSubscriptionButton', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: ['$scope', '$http', 'configService', controller],
            controllerAs: 'vm',
            templateUrl: paths.EmailSubscriptionView,
            scope: {
                folderId: '=',
                hasEmailSubscription: '=',
                hasOnlyFolderEmailSubscription: '=',
                readonlyFolderEmailSubscription: '='
            },
            link: function (scope, element, attr) {

            }
        };
    });

    function controller($scope, $http, configService) {
        var vm = this;
        $scope.requestUrl = '';
        $scope.requestType = '';
        vm.translation = globalResources;

        vm.simpleSubscription = configService.getBool(HandbookConfiguration.SimpleSubscription);

        vm.addRecursiveFolderEmailSubscription = addRecursiveFolderEmailSubscription;
        vm.remoteRecursiveFolderEmailSubscription = remoteRecursiveFolderEmailSubscription;
        vm.addOnlyFolderEmailSubscription = addOnlyFolderEmailSubscription;
        vm.reomteOnlyFolderEmailSubscription = reomteOnlyFolderEmailSubscription;

        function addRecursiveFolderEmailSubscription() {
            var requestUrl = handbookRequests.AddEmailSubscription + '/' + $scope.folderId;

            $http.post(requestUrl)
                .then(function () {
                    $scope.hasEmailSubscription = !$scope.hasEmailSubscription;
                    $scope.hasOnlyFolderEmailSubscription = false;
                    $scope.readonlyFolderEmailSubscription = true;
                });
        };

        function remoteRecursiveFolderEmailSubscription() {
            var requestUrl = handbookRequests.RemoveEmailSubscription + '/' + $scope.folderId;

            $http.post(requestUrl)
                .then(function () {
                    $scope.hasEmailSubscription = !$scope.hasEmailSubscription;
                    $scope.readonlyFolderEmailSubscription = false;
                });
        }

        function addOnlyFolderEmailSubscription() {
            if (!$scope.readonlyFolderEmailSubscription) {
                var requestUrl = handbookRequests.AddOnlyFolderToEmailSubscription + '/' + $scope.folderId;
                $http.post(requestUrl)
                    .then(function () {
                        $scope.hasOnlyFolderEmailSubscription = !$scope.hasOnlyFolderEmailSubscription;
                    });
            }
        }

        function reomteOnlyFolderEmailSubscription() {
            var requestUrl = handbookRequests.RemoveOnlyFolderFromEmailSubscription + '/' + $scope.folderId;
            $http.post(requestUrl)
                .then(function () {
                    $scope.hasOnlyFolderEmailSubscription = !$scope.hasOnlyFolderEmailSubscription;
                });
        }

        $scope.$on(broadcastType.toggleEmailSubscriptionTarget, function (e, target) {
            if (angular.element('#email-subscribe-folder-rec').hasClass('ng-hide')) {
                remoteRecursiveFolderEmailSubscription();
            } else {
                addRecursiveFolderEmailSubscription();
            }
        });

        $scope.$on(broadcastType.toggleOnlyFolderEmailSubscriptionTarget, function (e, target) {
            if (!vm.simpleSubscription) {
                if (angular.element('#email-subscribe-folder').hasClass('ng-hide')) {
                    reomteOnlyFolderEmailSubscription();
                } else {
                    addOnlyFolderEmailSubscription();
                }
            }
        });
    }

})();